import axios from 'axios';

const API_URL = 'http://127.0.0.1:5000';
const PRODUCTION_URL = '/AccessEvaApi';
//const PRODUCTION_URL = '/Api';

const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? PRODUCTION_URL : API_URL,
});

// Add a request interceptor to include the token in headers
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 403) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.error("Data:", error.response.data);
      console.error("Status:", error.response.status);
      console.error("Headers:", error.response.headers);

      // Dispatch the custom event with the error message
      const customEvent = new CustomEvent('forbidden403', {
        detail: { message: error.response.data.message || 'Access denied. Please upgrade your account.' }
      });
      window.dispatchEvent(customEvent);
    } else if (error.request) {
      // The request was made but no response was received
      console.error("Request:", error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('Error', error.message);
    }
    return Promise.reject(error);
  }
);

export const generateChatCompletion = async (query) => {
  try {
    const response = await api.post('/api/query', { query });
    return response.data;
  } catch (error) {
    console.error('Error generating chat completion:', error);
    throw error;
  }
};

export const register = (username, password, firstname, lastname, email, phone) => {
  return api.post('/register', { username, password, firstname, lastname, email, phone});
};

export const login = (username, password) => {
  return api.post('/login', { username, password });
};
export const verify2FA = (user_id, two_fa_code) => {
  return api.post('/verify-2fa', { user_id, two_fa_code });
};
export const adminlogin = (username, password) => {
  return api.post('/admin/login', { username, password });
};
export const getProtectedData = () => {
  return api.get('/protected');
};
export const sendPasswordReset = (email) => {
  return api.post('/reset-password-request', { email });
};
export const resetPassword = (token, password) => {
  return api.post(`/reset-password/${token}`, { password });
};
export const getUserFiles = () => {
  return api.get('/user_files');
};


export const getUserFilesStatus = async (fileIds) => {
  return api.post('/user_files_status',  { file_ids: fileIds });
};

export const getUserQuerySets = () => {
  return api.get('/user_querySets');
};
export const getUserProjects = () => {
  return api.get('/projects');
};

export const createProject = (projectData) => {
  return api.post('/projects', projectData);
};

export const updateProject = (projectId, projectData) => {
  return api.put(`/projects/${projectId}`, projectData);
};
export const queryFiles = (query, id, files, conversation_id) => {
  return api.post('/query_files', { query, id, files, conversation_id });
};

export const uploadFile = (formData) => {
  return api.post('/upload_file', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const getFileStatus = (fileId) => {
  return api.get(`/file_status/${fileId}`);
};

export const getAllFiles = () => {
  return api.get('/files');
};

export const deleteFile = (fileId) => {
  return api.delete(`/files/${fileId}`);
};

export const updateFile = (fileId, fileData) => {
  return api.put(`/files/${fileId}`, fileData);
};

export const addFileToProject = (projectId, fileId) => {
  return api.post(`/projects/${projectId}/files`, { file_id: fileId });
};
export const delFilesFromProject = (projectId, fileIds) => {
  return api.delete(`/projects/${projectId}/files`, { data: { file_ids: fileIds } });
};
export const getProjecUsers = () => {
  return api.get(`/projects/users`);
};
export const addUserToProject = (projectId, userId) => {
  return api.post(`/projects/${projectId}/users`, { user_id: userId });
};
export const delUsersFromProject = (projectId, userIds) => {
  return api.delete(`/projects/${projectId}/users`, { data: { user_ids: userIds } });
};
export const deleteProject = (projectId) => {
  return api.delete(`/projects/${projectId}`);
};

export const getProjectById = (projectId) => {
  return api.get(`/projects/${projectId}`);
};

export const getConversations = (projectId) => {
  return api.get(`/conversations/${projectId}`);
};
export const createConversation = (projectId) => {
  return api.post(`/conversations/${projectId}`);
};
export const deleteConversation = (conversationId) => {
  return api.delete(`/conversations/${conversationId}`);
};

export const updateConversation = (conversationId, data) => {
  return api.put(`/conversations/${conversationId}`, data);
};

export const getMessages = (conversationId) => {
  return api.get(`messages/${conversationId}`);
};


export const getUsers = () => {
  return api.get('/admin/users');
};
export const getUsers_ru = () => {
  return api.get('/admin/users_ru');
};
export const createUser = (data) => {
  return api.post('/admin/user', data);
};

export const updateUser = (userId, userData) => {
  return api.put(`/admin/users/${userId}`, userData);
};

export const deleteUser = (userId) => {
  console.log("userId=", userId);
  return api.delete(`/admin/users/${userId}`);
};

export const getAdminProjects = () => {
  return api.get('/admin/projects');
};
export const getAdminFiles = () => {
  return api.get('/admin/files');
};
export const updateFileAdmin = (fileId, fileData) => {
  return api.put(`/admin/files/${fileId}`, fileData);
};
export const getUserProfile = () => {
  return api.get('/user/profile');
};

export const updateUserProfile = (profileData) => {
  return api.put('/user/profile', profileData);
};

export const updatePassword = (passwordData) => {
  return api.put('/user/password', passwordData);
};


export const subscriptionPrice = () => {
  return api.get('/payment/subscriptionPrice');
};
export const subscriptionInfo = () => {
  return api.get('/payment/subscriptionInfo');
};

export const getPayments = () => {
  return api.get('/payment/getPayments');
};

export const processPaypalPayment = (data) => {
  return api.post('/payment/process-paypal-payment', data);
};

export const contact = (data) => {
  return api.post('/contact', data);
};


//add for admin

export const getQuestionSets = () => {
  return api.get('/admin/question-sets');
};

export const createQuestionSet = (data) => {
  return api.post('/admin/question-sets', data);
};

export const updateQuestionSet = (setId, data) => {
  return api.put(`/admin/question-sets/${setId}`, data);
};
export const deleteQuestionSet = (setId) => {
  return api.delete(`/admin/question-sets/${setId}`);
};

export const getQuestionSet = (setId) => {
  return api.get(`/admin/question-sets/${setId}`);
};

export const addQuestion = (setId, data) => {
  return api.post(`/admin/question-sets/${setId}/questions`, data);
};

export const updateQuestion = (setId, questionId, data) => {
  return api.put(`/admin/question-sets/${setId}/questions/${questionId}`, data);
};

export const deleteQuestion = (setId, questionId) => {
  return api.delete(`/admin/question-sets/${setId}/questions/${questionId}`);
};

//add for user

export const getQuestionSets_user = () => {
  return api.get('/user/question-sets');
};

export const createQuestionSet_user = (data) => {
  return api.post('/user/question-sets', data);
};

export const updateQuestionSet_user = (setId, data) => {
  return api.put(`/user/question-sets/${setId}`, data);
};
export const deleteQuestionSet_user = (setId) => {
  return api.delete(`/user/question-sets/${setId}`);
};

export const getQuestionSet_user = (setId) => {
  return api.get(`/user/question-sets/${setId}`);
};

export const addQuestion_user = (setId, data) => {
  return api.post(`/user/question-sets/${setId}/questions`, data);
};

export const updateQuestion_user = (setId, questionId, data) => {
  return api.put(`/user/question-sets/${setId}/questions/${questionId}`, data);
};

export const deleteQuestion_user = (setId, questionId) => {
  return api.delete(`/user/question-sets/${setId}/questions/${questionId}`);
};


//org


export const initOrganization = () => {
  return api.get('/admin/organization/init');
};
export const getOrganizations = () => {
  return api.get('/admin/organizations');
};

export const createOrganization = (data) => {
  return api.post('/admin/organization', data);
};

export const updateOrganization = (orgId,orgData) => {
  return api.put(`/admin/organization/${orgId}`, orgData);
};

export const createDepartment = (orgId,data) => {
  return api.post(`/admin/organizations/${orgId}/departments`, data);
};

export const updateDepartment = (orgId,id,data) => {
  return api.put(`/admin/organizations/${orgId}/departments/${id}`, data);
};
export const deleteDepartment = (orgId,id) => {
  return api.delete(`/admin/organizations/${orgId}/departments/${id}`);
};

export const getConfig = () => {
  return api.get('/config');
};


//project share
export const projectShare = (projectId,data) => {
  return api.post(`/projects/${projectId}/share`, data);
};
export const getUserById = (Id) => {
  return api.get(`/projects/users/${Id}`);
};
export const delProjectUserShare = (projectId,userId) => {
  return api.delete(`/projects/${projectId}/share/${userId}`);
};
export const getSharedProjects = () => {
  return api.get('/projects/shared-with-me');
};
 
//file share
export const getUsersWithFileAccess = (fileId) => {
  return api.get(`/files/users/${fileId}`);
};
export const fileShare = (fileId, data) => {
  return api.post(`/files/${fileId}/share`, data);
};
export const delFileUserShare = (fileId, userId) => {
  return api.delete(`/files/${fileId}/share/${userId}`);
};
export const getSharedFiles = () => {
  return api.get('/files/shared-with-me');
};


export const getFileDetails = (fileId) => {
  return api.get(`/files/${fileId}/details`);
};

export default api;